import { faSearch } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/sharp-regular-svg-icons'
import { ActionIcon, TextInput } from '@mantine/core'
import React from 'react'

import useDebouncedFilterValue from '../../hooks/useDebouncedFilterValue/useDebouncedFilterValues'
import { type FulltextFilterProps } from '../filter-control-bar'

const FulltextFilter = <T,>({
  definition,
  sortFilter,
  fulltextFilterTextInputProps = {},
}: FulltextFilterProps<T>): React.ReactElement => {
  const { value, onChange } = useDebouncedFilterValue<string>({
    filterDefinition: definition,
    sortFilter,
  })

  return (
    <TextInput
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      placeholder={definition.placeholder}
      size="sm"
      rightSectionWidth={40}
      icon={<FontAwesomeIcon icon={faSearch} />}
      rightSection={
        value ? (
          <ActionIcon
            color="tenant"
            variant="outline"
            loading={false}
            size={fulltextFilterTextInputProps.size ?? 'sm'}
            radius="xl"
            onClick={() => onChange('')}
          >
            <FontAwesomeIcon icon={faTimes} />
          </ActionIcon>
        ) : undefined
      }
      style={{
        flexGrow: 1,
      }}
      {...fulltextFilterTextInputProps}
    />
  )
}

export default FulltextFilter
